import { useFetchInterviewNextSection } from 'api/hooks/SequentialInterviews';
import React from 'react';
import { useParams } from 'react-router-dom';

import GlobalLoader from 'components/GlobalLoader';

import shortUrnToUrn from '../../../util/interviews/shortUrnToUrn';
import useRedirect from '../util/useRedirect';

const RedirectToNextPage: React.FC = () => {
  const { shortInterviewURN } = useParams();
  const redirect = useRedirect();
  const fullInterviewURN = shortUrnToUrn(shortInterviewURN!, 'interview');

  const { loading } = useFetchInterviewNextSection({
    params: { interviewURN: fullInterviewURN },
    onCompleted: (data) => redirect({ ...data, replace: true }),
  });

  if (loading) {
    return <GlobalLoader />;
  }

  return null;
};

export default RedirectToNextPage;
